module.exports = __webpack_public_path__ + "static/media/exclamation-triangle.4d4c1b16.svg";